import { AuthClient } from "./internal/AuthClient";

export type SignUpOptions = {
  /**
   * Used to prefill the email input on the sign-up page.
   */
  email?: string;
  /**
   * The invitation ID to redirect the user to the complete invite page after signing up.
   */
  invitationId?: string;
  /**
   * Flag to indicate whether the invite email address is already registered.
   */
  isEmailRegistered?: boolean;
  /**
   * The target page URL to redirect the user to after sign up, will be ignored if `invitationId` is provided.
   */
  target?: string;
};

export async function signUp({
  target,
  email,
  invitationId,
  isEmailRegistered,
}: SignUpOptions): Promise<void> {
  return AuthClient.loginWithRedirect({
    appState: { target, invitationId },
    authorizationParams: {
      screen_hint: isEmailRegistered ? undefined : "signup",
      login_hint: email,
    },
  });
}
